import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { RootState } from '../features';
import { actions } from '../features/user';
import { getQueryParam } from '../lib/utils';
import { Loading } from './shared/Loading';
import { LoadingFailed } from './shared/LoadingFailed';

export function Startup() {
  const location = useLocation();
  const history = useHistory();
  const country = getQueryParam(location.search, 'na_country');
  const raid = getQueryParam(location.search, 'raid');

  const { initialized, isLoading, users, marked, selectStatus, errorType } = useSelector(
    (state: RootState) => state.user
  );

  const dispatch = useDispatch();

  useEffect(() => {
    const language = navigator.language;
    if (country) {
      // NOTE: sessionStorageに保存してRestartRequiredページで使用する
      window.sessionStorage.setItem('na_country', country);
      dispatch(actions.setupLanguage({ language, country }));
    }
  }, [dispatch, country]);

  useEffect(() => {
    if (initialized) {
      dispatch(actions.getUserList());
    }
  }, [initialized, dispatch]);

  useEffect(() => {
    if (initialized && selectStatus === 'succeeded') {
      let dest: string;
      if (raid) {
        dest = `/deep-link/promotion/${raid}`;
      } else {
        dest = marked ? '/players/home' : '/walkthrough/1';
      }
      history.replace(dest);
    }
  }, [initialized, history, marked, selectStatus, raid]);

  if (!initialized || isLoading || selectStatus === 'loading') {
    return <Loading />;
  }

  if (errorType || selectStatus === 'failed') {
    return (
      <div
        className={css`
          padding-top: 164px;
        `}
      >
        <LoadingFailed error={errorType} />
      </div>
    );
  }

  if (users.length === 0) {
    return <Redirect to={{ pathname: '/lp', search: location.search }} />;
  } else {
    const dest = raid ? `/player-select?raid=${raid}` : '/player-select';
    return <Redirect to={dest} />;
  }
}
